import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
export var planBookListRoute = [{
  path: "planBookList",
  name: "planBookList",
  component: function component() {
    return import("./plan-book-list.vue");
  }
}];